import {Button, Modal, Tag, Upload, UploadFile, UploadProps} from 'antd'
const {CheckableTag} = Tag
import React, {useState} from 'react'
import {DatabasePlantRecord} from '../../services/PlantsService'
import './ImageUpload.less'
import './ImageTagView.less'
import {useIntl} from 'react-intl'
import {useAsyncValue} from '../../hooks/useAsyncValue'
import {instance as plantsService} from '../../services/PlantsService'
import {ArrayElementOf} from '../../services/util'
import type {UploadFileStatus} from 'antd/es/upload/interface'

function preparePhotos(
  plantName: string,
  fieldName: keyof DatabasePlantRecord['fields'] | 'Мои фотографии',
  urls: string[],
  tag?: string
) {
  if (!Array.isArray(urls)) {
    return []
  }

  return urls.map((url, index) => ({
    uid: index + tag,
    name: `${plantName}-${tag}-${index}`,
    status: 'done' as UploadFileStatus,
    url,
    photoType: fieldName,
  }))
}

export type ImageTagViewProps = {
  plantName: string
  userPhotos?: string[]
  basePlantPhotos?: string[]
  basePlantFlowerPhotos?: string[]
  basePlantLeavesPhotos?: string[]
  basePlantFruitsPhotos?: string[]
  plantBaseId?: string
}

// const filters = Object.fromEntries(
//   Object.entries(DatabasePlantRecordMetadata)
//     .filter(([key, meta]) => meta.type === 'photo')
//     .map(([key, meta]) => [key, false])
// )

// filters.user = false

const groups: {
  fieldName: keyof DatabasePlantRecord['fields']
  propName: keyof ImageTagViewProps
  tag?: string
}[] = [
  {fieldName: 'Фотографии растения', propName: 'basePlantPhotos', tag: 'b'},
  {fieldName: 'Фотографии цветов', propName: 'basePlantFlowerPhotos', tag: 'f'},
  {fieldName: 'Фотографии листьев', propName: 'basePlantLeavesPhotos', tag: 'l'},
  {fieldName: 'Фотографии плодов', propName: 'basePlantFruitsPhotos', tag: 'fr'},
]

export function ImageTagView(props: ImageTagViewProps) {
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewTitle, setPreviewTitle] = useState('')

  const handleCancel = () => setPreviewOpen(false)

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      return
    }

    setPreviewImage(file.url || (file.preview as string))
    setPreviewOpen(true)
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1))
  }

  const {value: imageList = [], error} = useAsyncValue<
    ArrayElementOf<ReturnType<typeof preparePhotos>>[]
  >(
    [] as any,
    async () => {
      let allPhotos: string[] = []

      for (const {propName} of groups) {
        if (props[propName]?.length > 0) {
          allPhotos = [...allPhotos, ...props[propName]]
        }
      }

      const photos = await plantsService.getPlantDatabaseImageURLs(props.plantBaseId, allPhotos)

      if (!photos.success) {
        return []
      }

      let index = 0
      let imageList: ArrayElementOf<ReturnType<typeof preparePhotos>>[] = []

      for (const {fieldName, propName, tag} of groups) {
        if (props[propName]?.length > 0) {
          imageList = [
            ...imageList,
            ...preparePhotos(
              props.plantName,
              fieldName,
              photos.urls.slice(index, index + props[propName].length),
              tag
            ),
          ]
          index += props[propName].length
        }
      }

      return imageList
    },
    [props.plantBaseId]
  )

  //////////////////////////////////////
  const intl = useIntl()

  const filters = Object.fromEntries(imageList?.map((image) => [image.photoType, true]) || [])
  const [viewedTypesOfPhotos, setviewedTypesOfPhotos] = useState(filters)
  const noFiltersSelected = Object.values(viewedTypesOfPhotos).every((type) => type === false)

  return (
    <div>
      {filters ? (
        <div className="image-tag-view__filters">
          {Object.entries(filters).map(([key]) => (
            <CheckableTag
              key={key}
              checked={viewedTypesOfPhotos[key]}
              onChange={(checked) =>
                setviewedTypesOfPhotos((current) => ({...current, [key]: checked}))
              }
            >
              {key}
            </CheckableTag>
          ))}

          {/* <Button
            onClick={async () => {
              setviewedTypesOfPhotos(filters)
            }}
            type="primary"
          >
            {intl.formatMessage({id: 'resetFilters'})}
          </Button> */}
        </div>
      ) : (
        <></>
      )}

      <Upload
        beforeUpload={() => false}
        showUploadList={{
          showRemoveIcon: false,
        }}
        fileList={imageList?.filter(
          (photo) => viewedTypesOfPhotos[photo.photoType] || noFiltersSelected
        )}
        listType="picture-card"
        onPreview={handlePreview}
      ></Upload>
      <Modal open={previewOpen} title={null} footer={null} onCancel={handleCancel}>
        <img alt="example" style={{width: '100%'}} src={previewImage} />
      </Modal>
    </div>
  )
}
